import { render } from "./CreateMember.vue?vue&type=template&id=683a923c"
import script from "./CreateMember.vue?vue&type=script&lang=js"
export * from "./CreateMember.vue?vue&type=script&lang=js"

import "./CreateMember.vue?vue&type=style&index=0&id=683a923c&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__